import Themeable from "vuetify/lib/mixins/themeable";

export default {
	name: "ChartableMixin",

	mixins: [ Themeable ],

	data: () => ( {
		printMatchMedia: window.matchMedia( "print" )
	} ),

	watch: {
		isDark: {
			handler() {
				this.setChartColors();
				this.updateChart();
			},
			immediate: true
		}
	},

	methods: {
		setChartColors() {
			window.Chart.defaults.global.defaultFontColor = this.isDark ? "#FAFAFA" : "#212121";
			window.Chart.defaults.scale.gridLines.color = this.isDark ? "#616161" : "#EEEEEE";
		},

		updateChart() {
			if ( this.$data._chart ) {
				this.$data._chart.update();
			}
		},

		resizeChart() {
			this.$data._chart.resize();
		},

		bindListeners() {
			if ( typeof window !== "undefined" ) {
				window.addEventListener( "beforeprint", this.resizeChart );
				window.addEventListener( "afterprint", this.resizeChart );
			}

			this.printMatchMedia.addListener( this.resizeChart );
		},

		unbindListeners() {
			if ( typeof window !== "undefined" ) {
				window.removeEventListener( "beforeprint", this.resizeChart );
				window.removeEventListener( "afterprint", this.resizeChart );
			}

			this.printMatchMedia.removeListener( this.resizeChart );
		}
	},

	mounted() {
		this.bindListeners();
	},

	beforeDestroy() {
		this.unbindListeners();
	}
};
